var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.payment_schedule_list") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mt-3 align-items-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("back-button", {
                        staticClass: "btnFilter_2 mr-2 btn-back",
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { cols: "auto" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter_2 mr-2 w-100",
                          on: { click: _vm.exportPaymentSchedule },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-upload" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("mandate.export")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter_2 mr-2 w-100",
                          on: {
                            click: function ($event) {
                              _vm.displayFilter = !_vm.displayFilter
                            },
                          },
                        },
                        [
                          _vm.displayFilter
                            ? _c("i", { staticClass: "fa-light fa-minus" })
                            : _c("i", { staticClass: "fa-light fa-plus" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("filter.fltr")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter_2 w-100",
                          on: { click: _vm.onRefresh },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-rotate-right" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.rfrsh")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-auto" }),
              _vm._v(" "),
              _vm.displayFilter
                ? _c(
                    "b-row",
                    {
                      staticClass:
                        "min-w-100 justify-content-start align-items-center",
                    },
                    [
                      _c("b-col", { attrs: { cols: "3" } }, [
                        _c(
                          "span",
                          { staticClass: "filter-item-title d-block mb-1" },
                          [_vm._v(_vm._s(_vm.$t("mandate.unique_mandate_rf")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.UMR,
                              expression: "UMR",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "filter-item-content w-100",
                          staticStyle: { padding: "0.13rem" },
                          attrs: {
                            placeholder: _vm.$t("mandate.unique_mandate_rf"),
                          },
                          domProps: { value: _vm.UMR },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.UMR = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "3" } }, [
                        _c(
                          "span",
                          { staticClass: "filter-item-title d-block mb-1" },
                          [_vm._v(_vm._s(_vm.$t("mandate.status_collection")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.Status,
                                expression: "Status",
                              },
                            ],
                            staticClass: "filter-item-content w-100",
                            staticStyle: { padding: "0.35rem" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.Status = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "All" } }, [
                              _vm._v("──────────"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.statuses, function (s) {
                              return _c(
                                "option",
                                { key: s.value, domProps: { value: s.value } },
                                [_vm._v(_vm._s(_vm.$t(s.label)))]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.viewMode === "calendar"
                        ? _c("b-col", { attrs: { cols: "3" } }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title d-block mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Webheader.date_begin"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("datetime-picker-custom", {
                                  staticClass: "mr-3",
                                  class: {
                                    "filter-item-input": true,
                                    "filter-item-input-complete":
                                      _vm.dateBeginFilter,
                                  },
                                  staticStyle: { padding: "0.35rem" },
                                  attrs: {
                                    format: "YYYY-MM-DD",
                                    periodFull: "",
                                    id: "filter-datebegin",
                                    customInputParentClass:
                                      "filter-item-content",
                                    customInputClass: "w-100",
                                    maxLength: 19,
                                    placeholderValue: _vm.$t(
                                      "common.datepicker_format_date3"
                                    ),
                                    inputIcon: "fa-solid fa-calendar",
                                    showTime: false,
                                  },
                                  model: {
                                    value: _vm.dateBeginFilter,
                                    callback: function ($$v) {
                                      _vm.dateBeginFilter = $$v
                                    },
                                    expression: "dateBeginFilter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewMode === "calendar"
                        ? _c("b-col", { attrs: { cols: "3" } }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title d-block mb-1",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Webheader.date_end")))]
                                ),
                                _vm._v(" "),
                                _c("datetime-picker-custom", {
                                  staticClass: "mr-3",
                                  class: {
                                    "filter-item-input": true,
                                    "filter-item-input-complete":
                                      _vm.dateEndFilter,
                                  },
                                  staticStyle: { padding: "0.35rem" },
                                  attrs: {
                                    format: "YYYY-MM-DD",
                                    periodFull: "",
                                    id: "filter-dateend",
                                    customInputParentClass:
                                      "filter-item-content",
                                    customInputClass: "w-100",
                                    maxLength: 19,
                                    placeholderValue: _vm.$t(
                                      "common.datepicker_format_date3"
                                    ),
                                    inputIcon: "fa-solid fa-calendar",
                                    showTime: false,
                                  },
                                  model: {
                                    value: _vm.dateEndFilter,
                                    callback: function ($$v) {
                                      _vm.dateEndFilter = $$v
                                    },
                                    expression: "dateEndFilter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewMode === "list"
                        ? _c("b-col", { attrs: { cols: "3" } }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title d-block mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mandate.date_due_next_start")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("datetime-picker-custom", {
                                  staticClass: "mr-3",
                                  class: {
                                    "filter-item-input": true,
                                    "filter-item-input-complete":
                                      _vm.dateBeginFilterNext,
                                  },
                                  staticStyle: { padding: "0.35rem" },
                                  attrs: {
                                    format: "YYYY-MM-DD",
                                    periodFull: "",
                                    id: "filter-datebegin",
                                    customInputParentClass:
                                      "filter-item-content",
                                    customInputClass: "w-100",
                                    maxLength: 19,
                                    placeholderValue: _vm.$t(
                                      "common.datepicker_format_date3"
                                    ),
                                    inputIcon: "fa-solid fa-calendar",
                                    showTime: false,
                                  },
                                  model: {
                                    value: _vm.dateBeginFilterNext,
                                    callback: function ($$v) {
                                      _vm.dateBeginFilterNext = $$v
                                    },
                                    expression: "dateBeginFilterNext",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewMode === "list"
                        ? _c("b-col", { attrs: { cols: "3" } }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "filter-item-title d-block mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mandate.date_due_next_end")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("datetime-picker-custom", {
                                  staticClass: "mr-3",
                                  class: {
                                    "filter-item-input": true,
                                    "filter-item-input-complete":
                                      _vm.dateEndFilterNext,
                                  },
                                  staticStyle: { padding: "0.35rem" },
                                  attrs: {
                                    format: "YYYY-MM-DD",
                                    periodFull: "",
                                    id: "filter-dateend",
                                    customInputParentClass:
                                      "filter-item-content",
                                    customInputClass: "w-100",
                                    maxLength: 19,
                                    placeholderValue: _vm.$t(
                                      "common.datepicker_format_date3"
                                    ),
                                    inputIcon: "fa-solid fa-calendar",
                                    showTime: false,
                                  },
                                  model: {
                                    value: _vm.dateEndFilterNext,
                                    callback: function ($$v) {
                                      _vm.dateEndFilterNext = $$v
                                    },
                                    expression: "dateEndFilterNext",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticClass:
                            "min-w-100 justify-content-end align-items-center",
                        },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex justify-content-end mt-3",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btnFilter_2 mr-2 w-100",
                                  attrs: { disabled: !_vm.hasInputFilter },
                                  on: { click: _vm.clearFilterFields },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.rst")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "btnFilter_2 w-100",
                                  on: { click: _vm.onRefresh },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.srch")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.displayFilter
                ? _c("hr", { staticClass: "mx-auto mb-4" })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-card",
                        { staticClass: "position-relative" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "position-absolute",
                              staticStyle: { right: "20px", top: "10px" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "small text-primary text-decoration-underline",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleView.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.viewMode === "calendar"
                                          ? _vm.$t("mandate.switch_list_view")
                                          : _vm.$t("mandate.switch_calendar")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "fade", mode: "out-in" } },
                            [
                              _vm.viewMode === "calendar"
                                ? _c(
                                    "div",
                                    {
                                      key: "calendar-view",
                                      staticClass: "p-3",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "calendar-header d-flex justify-content-center align-items-center mb-3",
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "light" },
                                              on: { click: _vm.prevYear },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-light fa-chevron-left",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("h3", { staticClass: "mx-3" }, [
                                            _vm._v(_vm._s(_vm.currentYear)),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "light" },
                                              on: { click: _vm.nextYear },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-light fa-chevron-right",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "calendar-grid-container",
                                        },
                                        [
                                          _c(
                                            "table",
                                            { staticClass: "calendar-grid" },
                                            [
                                              _c("thead", [
                                                _c(
                                                  "tr",
                                                  [
                                                    _c("th", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "mandate.month"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _vm._l(31, function (day) {
                                                      return _c(
                                                        "th",
                                                        { key: day },
                                                        [_vm._v(_vm._s(day))]
                                                      )
                                                    }),
                                                  ],
                                                  2
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.months,
                                                  function (month, monthIndex) {
                                                    return _c(
                                                      "tr",
                                                      { key: month },
                                                      [
                                                        _c("td", [
                                                          _vm._v(_vm._s(month)),
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          31,
                                                          function (day) {
                                                            return _c(
                                                              "td",
                                                              {
                                                                key: day,
                                                                class:
                                                                  _vm.cellClass(
                                                                    monthIndex,
                                                                    day
                                                                  ),
                                                                attrs: {
                                                                  title:
                                                                    _vm.getCellTitle(
                                                                      monthIndex,
                                                                      day
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.navigateToDetails(
                                                                        monthIndex +
                                                                          1,
                                                                        day
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm
                                                                  .filteredDebitMap[
                                                                  monthIndex +
                                                                    1 +
                                                                    "-" +
                                                                    day
                                                                ]
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "amount-cell",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              _vm.formatAmount(
                                                                                _vm
                                                                                  .filteredDebitMap[
                                                                                  monthIndex +
                                                                                    1 +
                                                                                    "-" +
                                                                                    day
                                                                                ]
                                                                                  .totalAmount
                                                                              )
                                                                            ) +
                                                                            "\n                            "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "legend mt-3" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "legend-item" },
                                            [
                                              _c("span", {
                                                staticClass: "box box-debit",
                                              }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("mandate.total")
                                                  ) +
                                                  " =\n                    " +
                                                  _vm._s(
                                                    _vm.$t("mandate.total_past")
                                                  ) +
                                                  " +\n                    0 (" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.total_reimbursed"
                                                    )
                                                  ) +
                                                  ") +\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.total_error"
                                                    )
                                                  ) +
                                                  " +\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.total_expected"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { key: "list-view", staticClass: "mt-4" },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _vm.listItemsPaymentSchedule.length >
                                          0
                                        ? _c("b-table", {
                                            key: _vm.refreshKey,
                                            staticClass: "table table-striped",
                                            staticStyle: {
                                              "margin-bottom": "0",
                                            },
                                            attrs: {
                                              striped: "",
                                              hover: "",
                                              responsive: "",
                                              items:
                                                _vm.listItemsPaymentSchedule,
                                              fields: _vm.fields,
                                              "sort-by": _vm.sortBy,
                                              "sort-desc": _vm.sortDir,
                                              "empty-text": _vm.$t(
                                                "common.security.no_result"
                                              ),
                                            },
                                            on: {
                                              "update:sortBy": function (
                                                $event
                                              ) {
                                                _vm.sortBy = $event
                                              },
                                              "update:sort-by": function (
                                                $event
                                              ) {
                                                _vm.sortBy = $event
                                              },
                                              "update:sortDesc": function (
                                                $event
                                              ) {
                                                _vm.sortDir = $event
                                              },
                                              "update:sort-desc": function (
                                                $event
                                              ) {
                                                _vm.sortDir = $event
                                              },
                                              "head-clicked": _vm.sortTable,
                                              "row-clicked": _vm.onRowClicked,
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "cell(amount)",
                                                fn: function (data) {
                                                  return [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formatCurrency(
                                                            data.item.amount
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(frequency)",
                                                fn: function (data) {
                                                  return [
                                                    data.value !== ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.frequency_type_" +
                                                                  data.value
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v("-"),
                                                        ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(nextDueDate)",
                                                fn: function (data) {
                                                  return [
                                                    data.value !== ""
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.formatDate(
                                                                  data.item
                                                                    .nextDueDate
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v("-"),
                                                        ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(status)",
                                                fn: function (data) {
                                                  return [
                                                    data.value !== ""
                                                      ? _c(
                                                          "span",
                                                          {
                                                            class: [
                                                              "chip",
                                                              "chip--" +
                                                                _vm.statusVariant(
                                                                  data
                                                                ),
                                                            ],
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "mandate.status_payment_schedule_" +
                                                                    data.value
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c("span", [
                                                          _vm._v("-"),
                                                        ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(actions)",
                                                fn: function (ref) {
                                                  var item = ref.item
                                                  return [
                                                    _c(
                                                      "b-link",
                                                      {
                                                        staticClass:
                                                          "text-decoration-none",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            $event.preventDefault()
                                                            return _vm.onRowClicked(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.view_details"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "noResult" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.no_result"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "mt-5" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("cm-pagination", {
                                                attrs: {
                                                  maxResultsByPage:
                                                    _vm.paginationObject
                                                      .maxResults,
                                                  firstIndex:
                                                    _vm.paginationObject
                                                      .firstIndex,
                                                  nbResultsTotal:
                                                    _vm.paginationObject
                                                      .nbResultsTotal,
                                                  refreshEvent:
                                                    _vm.paginationObject
                                                      .refresh,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }